<script setup lang="ts">
import '@/assets/scss/form.scss'
import { yupResolver } from '@primevue/forms/resolvers/yup'
import { useConfirm } from 'primevue'
import { useToast } from 'primevue/usetoast'
import { ref } from 'vue'
import { useAuthStore } from '@/onenetwork/stores/onenetwork.store.auth.ts'
import * as yup from 'yup'
import { Icon } from '@iconify/vue/dist/iconify.js'
import { REGEX } from '@/onenetwork/constants/onenetwork.regex.const'
import { schemaChangePW } from '../helper/validationAccountSchema'

const confirm = useConfirm()
const authStore = useAuthStore()
interface Props {
  account: any
  closeModal?: any
}

const props = defineProps<Props>()
const emit = defineEmits(['update:closeModal'])
const toast = useToast()
const loading = ref(false)
const initialValues = ref({
  current_password: '',
  new_password: '',
  new_password_confirmation: '',
})
const resolver = yupResolver(schemaChangePW)
const requestChangePW = async (data: any) => {
  try {
    loading.value = true
    authStore.changePW(data).then((res) => {
      loading.value = false
      emit('update:closeModal')
      toast.add({
        severity: 'success',
        summary: 'Thay đổi mật khẩu thành công',
        detail: `Thay đổi mật khẩu thành công, vui lòng đăng nhập lại`,
        life: 2000,
      })
    }).catch((e) => {
      loading.value = false
      toast.add({
        severity: 'error',
        summary: e?.response?.data?.message,
        detail: e?.response?.data?.message,
        life: 2000,
      })
    })
  } catch (e) {
    loading.value = false
    toast.add({
      severity: 'error',
      summary: 'Thay đổi mật khẩu thất bại',
      detail: `Thay đổi mật khẩu thất bại, vui lòng thử lại`,
      life: 2000,
    })
  }
}

const onFormSubmit = ({ values, valid }: any) => {
  if (!valid) {
    return
  }
  confirm.require({
    message: 'Bạn có muốn thay đổi mật khẩu?',
    header: 'Xác nhận',
    // icon: 'pi pi-exclamation-triangle',
    rejectProps: {
      label: 'Huỷ',
      severity: 'secondary',
      outlined: true,
    },
    acceptProps: {
      label: 'Đồng ý',
    },
    accept: () => {
      requestChangePW(values)
    },
    reject: () => {
      // toast.add({ severity: 'error', summary: 'Rejected', detail: 'You have rejected', life: 3000 });
    },
  })
}
</script>

<template>
  <div class="pt-3">
    <Form
      v-slot="$form"
      :initial-values="initialValues"
      :resolver="resolver"
      @submit="onFormSubmit"
      class="flex flex-col w-full"
    >
      <div class="flex flex-col flex-3">
        <div class="flex mb-3 gap-3">
          <div class="flex-1 text-[12px] mb-1 text-right">Mật khẩu hiện tại:</div>
          <div class="flex-2">
            <InputText name="current_password" type="password" class="form-control py-[7px]" />
            <span class="font-italic text-[12px] text-red-500">
              {{$form?.current_password?.error?.message}}
            </span>
          </div>
        </div>
        <div class="flex mb-3 gap-3">
          <div class="flex-1 text-[12px] mb-1 text-right">Mật khẩu mới:</div>
          <div class="flex-2">
            <InputText name="new_password" type="password" class="form-control py-[7px]" />
            <span class="font-italic text-[12px] text-red-500">
              {{$form?.new_password?.error?.message}}
            </span>
          </div>
        </div>
        <div class="flex mb-3 gap-3">
          <div class="flex-1 text-[12px] mb-1 text-right">Xác nhận mật khẩu mới:</div>
          <div class="flex-2">
            <InputText name="new_password_confirmation" type="password" class="form-control py-[7px]" />
            <span class="font-italic text-[12px] text-red-500">
              {{$form?.new_password_confirmation?.error?.message}}
            </span>
          </div>
        </div>
        <div class="flex mb-3 gap-3">
          <div class="flex-1 text-right"></div>
          <div class="flex-2">
            <CsButton
              type="submit"
              :disabled="loading"
              :loading="loading"
              text="Thay đổi mật khẩu"
            />
          </div>
        </div>
      </div>
    </Form>
  </div>
</template>
